var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"row-pointer",attrs:{"headers":_vm.headers,"items":_vm.parents,"items-per-page":5,"loading":_vm.isLoading,"disable-sort":"","footer-props":{
    itemsPerPageOptions: [5],
  }},on:{"click:row":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }